/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.

import classnames from 'classnames'

import PropTypes from 'prop-types'

import 'styles/components/settings/tags/ManageTagDropdown.styl'

const ManageTagDropdown = React.createClass({
  mixins: [require('react-onclickoutside')],

  propTypes: {
    editTagClicked: PropTypes.func.isRequired
  },

  componentDidMount() {
    return this.enableOnClickOutside()
  },

  handleClickOutside(event) {
    return this.props.handleClickOutside()
  },

  render() {
    return (
      <div className="ManageTagDropdown">
        <div onClick={this.props.editTagClicked}>
          Edit
        </div>
        <div onClick={this.props.deleteTagClicked}>
          Delete
        </div>
      </div>
    )
  }
})

export default ManageTagDropdown



// WEBPACK FOOTER //
// ./src/scripts/components/settings/tags/ManageTagDropdown.js